import { Row, Col } from 'react-bootstrap';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

export const PageHeader = ({ title, subtitle }: PageHeaderProps) => {
  return (
    <Row className="mb-4 align-items-center">
      <Col>
        <h2 className="mb-1">{title}</h2>
        {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
      </Col>
    </Row>
  );
};

